//* Vue
import type { ExtractPropTypes } from "vue";
//* 局部公共组件
import type { ModuleData as ModuleMutation } from "../mutations";

export const ModulePropsOption = {
    id: { type: String, required: true },
    mode: { type: String, required: true },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;

export type ModuleData = {
    classifications?: string;
    mutation_number: number;
    search_number: number;
    mutations: ModuleMutation[];
    number: number;
    source: number;
    organ?: { icon: string; name: string }[];
    name: string;
    id: string | number;
};
